// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { TerceraButton } from '../elements/TerceraButton';
export class MDButton extends TerceraButton {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.observe('tradingAllowed tradingForbiddenReason', this.onTradingRulesChanged);
        this.observe('locKey', this.localize);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    localize() {
        void this.set('text', Resources.getResource(this.get('locKey')));
    }
    onTradingRulesChanged() {
        const tradingAllowed = this.get('tradingAllowed');
        const tradingForbiddenReason = this.get('tradingForbiddenReason');
        void this.set({
            enabled: tradingAllowed,
            tooltip: tradingAllowed || !tradingForbiddenReason ? '' : tradingForbiddenReason
        });
    }
}
TerceraButton.extendWith(MDButton, {
    data: () => {
        return {
            tradingAllowed: false,
            tradingForbiddenReason: '',
            locKey: '',
            style: ''
        };
    }
});
